import React from 'react';
import PropTypes from 'prop-types';
import Panel from 'panelComponents/Panel';
import PackageList from 'accountComponents/PackageList';
import OrderServiceList from 'accountComponents/OrderServiceList';
import {Tabs, Tab} from 'material-ui/Tabs';

class AccountPackagePanel extends React.PureComponent {

    constructor(props, context) {
        super(props, context);

        this.handleChange = this
            .handleChange
            .bind(this);

        this.state = {
            value: 'packages'
        };
    }

    handleChange(value) {
        this.setState({value: value});
    }
    render(){
        const {packages, orderServices} = this.props;
        const marginStyle = {marginTop: 2};
        return (
            <div style={marginStyle}>
                <Panel loading={false} hasDetails={true}>
                    <Tabs onChange={this.handleChange} 
                        value={this.state.value}>
                        <Tab label="All" value="packages">
                            <PackageList packages={packages}/></Tab>
                        <Tab label="Packages"  value="services">
                            <OrderServiceList orderServices={orderServices}/></Tab>
                    </Tabs>
                </Panel> 
            </div>
     
        );
    
    }

}

AccountPackagePanel.propTypes = {
    packages: PropTypes.object,
    orderServices: PropTypes.object,
};

export default AccountPackagePanel;


// WEBPACK FOOTER //
// ./src/components/account/AccountPackagePanel.js